/**
 * Turns 1500.015123 into 1500.02
 */
export function getValueAsFloat(value: number): number {
  return Math.round(value * 100) / 100;
}

export function countDecimals(number: number): number {
  if (Number.isInteger(number)) {
    return 0;
  }

  const decimalStr: string = number.toString().split('.')[1];
  return decimalStr.length;
}

export function randomNumber(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Turns $1,000.00 into 1000.00
 */
export function extractFloat(value: string): number {
  return parseFloat(value.replace(/[^\d.]/g, ''));
}

export function calculatePercentageChange(previousCount: number, currentCount: number): number {
  if (previousCount === 0) {
    return currentCount === 0 ? 0 : 100;
  }

  return ((currentCount - previousCount) / previousCount) * 100;
}
